// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"5cd55fd1","450":"23167ee6","453":"f173fc76"}[chunkId] + ".chunk.js";
};